import React, { Component } from 'react';
import "./NewHeader.css";
import Logo from "../../assets/images/logo/logo-02.png";
import Icon from "../../assets/images/favicon.ico";
import BannerTabNav from '../BannerTabNav'
import CartDropDown from '../Cart/CartDropDown';
import { BrowserRouter, Link, Switch, Route, Redirect } from "react-router-dom";
import { setCustomerLogin, getGeoInfo, getCustomerLogin, LoginConfirmation } from '../axios';
import Modal from 'react-modal';
import FacebookLogin from 'react-facebook-login';
import { GoogleLogin, GoogleLogout } from 'react-google-login';
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from 'react-cookie';
import moment from 'moment';
import SignUp from '../SignUp';
import { connect, Provider } from 'react-redux';

import { Base64 } from 'js-base64';

class NewHeaderStatic extends Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) {
        super(props);

        const { cookies } = props;
        this.state = {
            nav: false,
            modalIsOpen: false,
            ChangeLoginScreenClass: 'containerLogin',
            facebookLogin: false,
            facebookResponse: {},
            GoogleLoginButton: false,
            GoogleResponse: {},
            country: '',
            country_code: '',
            currency: '',
            ip_address: '',
            customerEmail: cookies.get('userDetails') || '',
            customerEmailForData: localStorage.getItem('userDetails') || 'abc',
            customerDetails: {},
            profileNew: false,
            profileNewAgain: false,
            cartProfileNewAgain: false,
            LoginEmail: '',
            LoginPassword: '',
            errorPassword: false,
        }
    }

    handleScroll = () => {
        if (this.props.page == 'inner') {
            if (window.pageYOffset > 60) {
                if (!this.state.nav) {
                    this.setState({ nav: true });
                }
            } else {
                if (this.state.nav) {
                    this.setState({ nav: false });
                }
            }
        } else if (this.props.page == 'inner_listing') {
            if (window.pageYOffset > 60) {
                if (!this.state.nav) {
                    this.setState({ nav: true });
                }
            } else {
                if (this.state.nav) {
                    this.setState({ nav: false });
                }
            }

        }
    }
    openModal = () => {
        this.setState({ modalIsOpen: true });
    }


    closeModal = () => {
        this.setState({ modalIsOpen: false });
    }
    ChangeLoginEmail = (event) => {
        this.setState({ LoginEmail: event.target.value });
    }

    ChangeLoginPassword = (event) => {
        this.setState({ LoginPassword: event.target.value });
    }

    LoginConfirm = (e) => {
        e.preventDefault();
        this.setState({ errorPassword: false });
        let emailNew = this.state.LoginEmail;
        let email = '';
        if (emailNew.length > 0) {
            email = emailNew;
        } else {
            email = this.state.customerEmail.email;
        }
        let password = this.state.LoginPassword;

        LoginConfirmation(email, password).then(
            (data) => {
              
                if (data == 'not_correct') {
                    this.setState({ errorPassword: true });
                } else {
                    this.setState({ customerDetails: data });

                    let Verified = '';
                    if (data.verified == 1) {
                        Verified = true;
                    }

                    const dataSearch = {
                        first_name: data.first_name,
                        last_name: data.last_name,
                        email: data.email,
                        country_code: data.country_code,
                        verified: Verified,
                        uid: data.id
                    }

                    let JsonData = JSON.stringify(dataSearch);

                    localStorage.setItem('userDetails', JsonData);
                    window.location.reload(true);
                }

            },
            (error) => {

            });
    }

    ChangeLoginScreen = () => {
        this.setState({ ChangeLoginScreenClass: 'containerLogin right-panel-active' })
    }
    ChangeLoginReverse = () => {
        this.setState({ ChangeLoginScreenClass: 'containerLogin' })
    }
    componentDidMount() {
      //  let userData = localStorage.getItem("userDetails");
      const userData = localStorage.getItem('userDetails');

    //   if(userData == "abc"){
    //    var base_url = window.location.origin;
    //    window.location.href = base_url;
    //   }else{
     
        getGeoInfo().then(
            (data) => {
               
                this.setState({ country: data.country_name });
                this.setState({ country_code: data.country_calling_code });
                this.setState({ currency: data.currency });
                this.setState({ ip_address: data.ip });
            },
            (error) => {

            });


        if (userData != null) {
            const { cookies } = this.props;

            let newData = JSON.parse(userData);
            getCustomerLogin(newData.email).then(
                (data) => {
                  
                    // this.setState({ customerDetails: data });

                    // let Verified = '';
                    // if (data.verified == 1) {
                    //     Verified = true;
                    // }

                    // const dataSearch = {
                    //     first_name: data.first_name,
                    //     last_name: data.last_name,
                    //     email: data.email,
                    //     country_code: data.country_code,
                    //     verified: Verified,
                    //     uid: data.id
                    // }

                    // let JsonData = JSON.stringify(dataSearch);

                    // localStorage.setItem('userDetails', JsonData)
                    this.setState({ customerDetails: data });
                    if (data.user == "nouser") {
                      let Verified = "";
                      if (data.agent.verified == 1) {
                        Verified = true;
                      }
        
                      const dataSearch = {
                        first_name: data.agent.first_name,
                        last_name: data.agent.last_name,
                        email: data.agent.email,
                        country_code: data.agent.country_code,
                        verified: Verified,
                        uid: data.agent.id,
                        agent_id: data.agent.id,
        
                      };
        
                      let JsonData = JSON.stringify(dataSearch);
        
                      localStorage.setItem("userDetails", JsonData);
                    } else {
                      let Verified = true;
        
                      const dataSearch = {
                        first_name: data.user.user_first_name,
                        last_name: data.user.user_last_name,
                        email: data.user.user_email,
                        country_code: data.user.country_code,
                        verified: Verified,
                        uid: data.user.user_id,
                        agent_id: data.agent.id,
                      };
        
                      let JsonData = JSON.stringify(dataSearch);
        
                      localStorage.setItem("userDetails", JsonData);
                    }

                },
                (error) => {

                });
        }
     // }
       

        window.addEventListener("scroll", this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('click', this.globalClickListener);
    }

    globalClickListener = (nativeEvent) => {

        this.setState({ profileNew: false, profileNewAgain: false ,  cartProfileNewAgain: false}, () => {
           
            // document.removeEventListener('click', this.globalClickListener)
            window.removeEventListener('click', this.globalClickListener)
        })
    }

    OpenProfilelinkAgain = (syntheticEvent) => {
       
        syntheticEvent.stopPropagation();
        this.setState(prevState => ({ profileNewAgain: !prevState.profileNewAgain }), () => {
            if (this.state.profileNewAgain) {
               

                // document.addEventListener('click', this.globalClickListener)
                window.addEventListener('click', this.globalClickListener)
            }
        })
       
    }

    OpenCartProfilelinkAgain = (syntheticEvent) => {
       
        syntheticEvent.stopPropagation();
        this.setState(
          (prevState) => ({ cartProfileNewAgain: !prevState.cartProfileNewAgain }),
          () => {
            if (this.state.cartProfileNewAgain) {
              window.addEventListener("click", this.globalClickListener);
            }
          }
        );
       
      };


    LoginFaceBook = () => {
       
        this.setState({ facebookLogin: true });
    }

    responseFacebook = (response) => {
        const { cookies } = this.props;
      
        if (response.accessToken) {
            this.setState({ facebookResponse: response });
            let Name = response.first_name;

            let first_name = response.first_name;
            let last_name = response.last_name;
            let email = response.email;
            let profile_image = response.picture.data.url;
            let birthday = moment(response.birthday).format("Y-MM-DD");
            let gender = response.gender;
            let login_source = 1;


            let mobile_number = "";
            let country = this.state.country;
            let country_code = this.state.country_code;
            let currency = this.state.currency;
            let ip_address = this.state.ip_address;
            let password = "";
            let verified = 1;

            let Verified = '';
            if (verified == 1) {
                Verified = true;
            }

            const dataSearch = {
                first_name: first_name,
                last_name: last_name,
                email: email,
                country_code: country_code,
                verified: Verified,
                uid: ""
            }

            let JsonData = JSON.stringify(dataSearch);

            localStorage.setItem('userDetails', JsonData);
            cookies.set('userDetails', JsonData, { path: '/' });

            setCustomerLogin(first_name, last_name, email, profile_image, birthday, gender, login_source, mobile_number, country, country_code, currency, ip_address, password, verified).then(
                (data) => {
                  
                    if (data.id > 0) {
                        window.location.reload(true);
                    }
                },
                (error) => {

                }
            );
            this.setState({ modalIsOpen: false });
            // window.location.reload(true);

        }
    }

    responseGoogle = (response) => {

        if (response.accessToken) {
            const { cookies } = this.props;
            this.setState({ GoogleResponse: response });

            let first_name = response.profileObj.givenName;
            let last_name = response.profileObj.familyName;
            let email = response.profileObj.email;
            let profile_image = response.profileObj.imageUrl;
            let birthday = "";
            let gender = "";
            let login_source = 2;


            let mobile_number = "";
            let country = this.state.country;
            let country_code = this.state.country_code;
            let currency = this.state.currency;
            let ip_address = this.state.ip_address;
            let password = "";
            let verified = 1;

            let Verified = '';
            if (verified == 1) {
                Verified = true;
            }

            const dataSearch = {
                first_name: first_name,
                last_name: last_name,
                email: email,
                country_code: country_code,
                verified: Verified,
                uid: ""
            }

            let JsonData = JSON.stringify(dataSearch);

            localStorage.setItem('userDetails', JsonData);
            cookies.set('userDetails', JsonData, { path: '/' });

            setCustomerLogin(first_name, last_name, email, profile_image, birthday, gender, login_source, mobile_number, country, country_code, currency, ip_address, password, verified).then(
                (data) => {
                 
                    if (data.id > 0) {
                        window.location.reload(true);
                    }
                },
                (error) => {

                }
            );
            this.setState({ modalIsOpen: false });
            // window.location.reload(true);
        }
    }

    logoutChange = () => {
        localStorage.clear();
       // window.location.reload(true);
       var base_url = window.location.origin;
       window.location.href = base_url;
    }
    render() {

        return (
            <>
                <div className={`chHeaderWrapper ${this.state.nav == true ? ' Nav' : ' stickyHeader'}`} style={{ animation: 'slideInDown 0.00s linear', height: '10%' }}>
                    <div className="chHeaderContainer">
                    {this.state.customerEmailForData == 'abc' ? (<span className="logoContainer">
                            <a className="chMmtLogo" href="/"><img src="images/logo/seyLogo.png" alt="Holiday Seychelles" style={{ width: 100 }} /></a></span>) : (
                        <span className="logoContainer">
                            <a className="chMmtLogo" href="/home"><img src="images/logo/seyLogo.png" alt="Holiday Seychelles" style={{ width: 100 }} /></a></span>)}

                        {/* <BannerTabNav

                                        tabs={['Accommodations', 'Attractions & Things to Do', 'Packages', 'Land & Ferry Transfers', 'Liveaboard']}
 
                                        selected={this.props.Location}>
                                    </BannerTabNav> */}
                        <nav>
                            <ul className="hsFlex_Bann font12">
                                {/* <li className="menu_Hotels">
                                    <a href={"/home/?t=" + Base64.btoa(1)} smooth={true} className=" hsFlex_Bann hsCenter column"><span className="chNavIcon appendBottom2 chSprite chHotels "></span><span className={`chNavText darkGreyText ${this.props.tabName === 1 ? ' active' : ' '}`}> Accommodations </span></a>
                                </li>
                                <li className="menu_Villasmore">
                                    <a href={"/home/?t=" + Base64.btoa(2)} smooth={true} className="hsFlex_Bann hsCenter column"><span className="chNavIcon appendBottom2 chSprite chHomestays"></span><span className={`chNavText darkGreyText ${this.props.tabName === 2 ? ' active' : ' '}`}> Attractions &amp; Things to Do</span></a></li>

                                <li className="menu_Holidays"><a href={"/home/?t=" + Base64.btoa(3)} className="hsFlex_Bann hsCenter column"><span className="chNavIcon appendBottom2 chSprite chHolidays"></span><span className={`chNavText darkGreyText ${this.props.tabName === 3 ? ' active' : ' '}`}> Packages </span></a></li>

                                <li className="menu_Trains"><a href={"/home/?t=" + Base64.btoa(4)} className="hsFlex_Bann hsCenter column"><span className="chNavIcon appendBottom2 chSprite chTrains"></span><span className={`chNavText darkGreyText ${this.props.tabName === 4 ? ' active' : ' '}`}> Land & Ferry Transfers </span></a></li>

                                <li className="menu_Buses">
                                    <a href={"/home/?t=" + Base64.btoa(5)} className="hsFlex_Bann hsCenter column"><span className="chNavIcon appendBottom2 chBuses"></span><span className={`chNavText darkGreyText ${this.props.tabName === 5 ? ' active' : ' '}`}> Liveaboard </span></a></li> */}

                            </ul>
                        </nav>


                        <ul className="userSection pushRight">
                            {/* <li className="hsFlex_Bann hsCenter lhMyWallet"><span className="landingSprite walletBlanceIcon appendRight10">&nbsp;</span><span></span>
                            </li> */}
                            {this.state.customerEmailForData == 'abc' ? (<></>) : (

                                <li className="hs-LoginFlex hsCenter font10 hsRelative hsUser userLoggedIn">
                                    {this.state.customerDetails.profile_pic == "" ? (<span className="userNameIcon whiteText hs-LoginFlex perfectCenter latoBlack appendRight10"><span>{this.state.customerDetails.first_name.charAt(0)}</span></span>) : (
                                        <span className="userNameImage  appendRight10">
                                            <img style={{ width: '100%', borderRadius: '100%' }} src={this.state.customerDetails.profile_pic} />
                                        </span>
                                    )}


                                    <div className="hs-LoginFlex column userNameText  latoBold">
                                        <p data-cy="loggedInUser" className="appendBottom3 truncate customerName" >Hey {this.state.customerDetails.first_name}</p>
                                    </div>
                                    {/* {this.state.profileNewAgain &&

                                        <div className="userDropdown fadeInDown hs-LoginFlex column dropbanner">

                                            <a className="userItems hs-LoginFlex" href="/PlanTrips" target="_blank">
                                                <span className="landingSprite userItemMyTrips appendRight20"></span>
                                                <div>
                                                    <p className="font16 latoBold blackText appendBottom5">My Bookings</p>
                                                    <p className="font12 lineHeight16 blackText">See booking details, planned your own trip, Cancel Booking &amp; more.</p>
                                                </div>
                                            </a>
                                            

                                            <a className="userItems hs-LoginFlex" href="/Profile" target="_blank">
                                                <span className="landingSprite userItemMyProfile appendRight20"></span><div>
                                                    <p className="font16 latoBold blackText appendBottom5 hs-LoginFlex hsCenter">My Profile</p><p className="font12 lineHeight16 blackText">Manage your profile,  login details and  password</p>

                                                </div>
                                            </a>
                                            <a className="userItems hs-LoginFlex appendBottom10" onClick={this.logoutChange}><span className="landingSprite userItemLogout appendRight20"></span><div><p className="font16 latoBold blackText appendBottom5 hs-LoginFlex hsCenter">Logout</p></div></a>

                                        </div>
                                    } */}
                                </li>

                                
                            )}

                        {/* <li className="hsFlex_Bann hsCenter font10 hsRelative">
                            <div className="hsFlex_Bann column flexOne latoBold"  onClick={this.OpenCartProfilelinkAgain}>
                            <p className="appendBottom3_Header">
                               
                                   <a href="javascript:void(0)" class="cart position-relative d-inline-flex" aria-label="View your shopping cart">
                                   <img src="images/cart/ecommerce.png" className=" travel_blog appendRight10"/> 
                                    <span class="cart-basket d-flex align-items-center justify-content-center">
                                    {this.props.showcart.cardItems.cardData.length}
                                    </span>
                                    </a>
                            </p>
                            </div>
                            {this.state.cartProfileNewAgain && (
                        <CartDropDown showcart={this.props.showcart.cardItems.cardData}></CartDropDown>
                            )}
                      </li> */}
                        </ul>
                    </div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={this.closeModal}
                        style={this.customStyles}
                        contentLabel="Example Modal"
                    >

                        <div className={this.state.ChangeLoginScreenClass}>
                            <div className="form-container sign-up-container">
                                <form className="FormCon">
                                    <h1>Create Account</h1>
                                    <SignUp country_code={this.state.country_code} currency={this.state.currency} ip_address={this.state.ip_address} country={this.state.country} />

                                </form>
                            </div>
                            {this.state.facebookLogin && <FacebookLogin
                                appId="426993597895758"
                                autoLoad={true}
                                fields="first_name, last_name, email, picture, birthday,gender"
                                scope="public_profile, email, user_birthday,user_gender"
                                returnScopes={true}
                                callback={this.responseFacebook}
                            />}
                            {/* {this.state.GoogleLoginButton &&
                  
                        } */}
                            <div className="form-container sign-in-container">
                                <form className="FormCon" action="#">
                                    <h1>LOG IN</h1>
                                    {this.state.errorPassword && <p className="error"> Email or Password is not correct !</p>}
                                    <input type="email" placeholder="Email" value={this.state.LoginEmail ? this.state.LoginEmail : this.state.customerEmail.email} onChange={this.ChangeLoginEmail} />
                                    <input type="password" placeholder="Password" value={this.state.LoginPassword} onChange={this.ChangeLoginPassword} />
                                    <a href="#">Forgot your password?</a>
                                    <button onClick={this.LoginConfirm}>LOG IN</button>
                                    <div className="SocialmakeFlex socialBtnContainer vrtlCenter"><div className="SocialmakeFlex fbLoginBtn flexOne" onClick={this.LoginFaceBook}><span className=" popupSprite popupFbIcon"></span><span className="font14 whiteText latoBold latoBold" style={{ textTransform: 'uppercase' }}>Login with Facebook</span></div></div>
                                    <div className="SocialmakeFlex socialBtnContainer vrtlCenter">
                                        <div className="SocialmakeFlex googleLoginBtn flexOne"><span style={{ width: '100%' }}> <GoogleLogin
                                            clientId="924181911314-6ml7tmqad8dkh9ugosligld4b9kkremq.apps.googleusercontent.com"
                                            buttonText="Login with Google"
                                            onSuccess={this.responseGoogle}
                                            onFailure={this.responseGoogle}
                                            cookiePolicy={'single_host_origin'}

                                        /></span></div>
                                    </div>

                                </form>
                            </div>
                            <div className="overlay-container">
                                <div className="overlay">
                                    <div className="overlay-panel overlay-left">
                                        <h1>Welcome Back!</h1>
                                        <p>To keep connected with us please login with your personal info</p>
                                        <button className="ghost" onClick={this.ChangeLoginReverse}>LOG IN</button>
                                    </div>
                                    <div className="overlay-panel overlay-right">
                                        <h1>Hello, Friend!</h1>
                                        <p>Enter your personal details and start journey with us</p>
                                        <button className="ghost" onClick={this.ChangeLoginScreen}>Sign Up</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>

                </div>
            </>
        )
    }
}
const mapDispatchToProps= (dispatch)=>{
    
//   return{
//       addToCart: (item)=>{dispatch(addToCart(item))}
//   }
}
const mapStateToProps = (state, ownProps = {}) => {
  
    return{
        showcart:state
    }
  }

export default   connect(mapStateToProps, mapDispatchToProps) (withCookies(NewHeaderStatic));
